export enum BlockType {
  Async = "async",
  Sync = "sync",
}
